import { Button, Form, Input, message, Modal, Select, Spin, Tooltip } from "antd"
import { BiMinus, BiPlus } from "react-icons/bi"
import { CiGlobe } from "react-icons/ci"
import { FaUserTimes } from "react-icons/fa"
import { FaLinkedinIn, FaTwitter, FaUser } from "react-icons/fa6"
import { IoCopyOutline } from "react-icons/io5"
import { Rnd } from "react-rnd"
import defaultProfilePicutre from '../../assets/apollo/defaultProfilePicture.png'
import { usePostHog } from "posthog-js/react"
import { apSearch } from "../../lib/apSearch.ts";
import { apEnrichment } from "../../lib/apEnrichment.ts";
import { apGetEnrichment } from "../../lib/apGetEnrichment.ts"
import PlusIcon from '../../assets/svg/plus.svg'
import MinusIcon from '../../assets/svg/minus.svg'
import SearchIcon from '../../assets/svg/search.svg'


type EnrichmentModalProps = {
    enrichmentModalVisible: boolean;
    setEnrichmentModalVisible: (value: boolean) => void;
    domainToEnrich: string | undefined;
    setDomainToEnrich: (value: string | undefined) => void;
    enrichmentQuantity: number;
    setEnrichmentQuantity: (value: number) => void;
    setSelectedLevels: (levels: string[]) => void;
    selectedLevels: string[];
    setSelectedRecord: (value: any) => void;
    selectedRecord: any;
    resultData: any[];
    actualPage: number;
    pageSize: number;
    actualPageSize: number;
    haveEnrichmentCredits: boolean;
    companyLoading: boolean;
    setCompanyLoading: (value: boolean) => void;
    enrichAllResultsLoading: boolean;
    setEnrichAllResultsLoading: (value: boolean) => void;
    enrichingEmploee: string[] | undefined;
    setEnrichingEmploee: any;
    enrichmentResultKey: number;
    setEnrichMentResultKey: (value: number) => void;
    setApolloKey: (value: number) => void;
    setRequestErichmentCredtisKey: (value: number) => void;
    enrichPerson: any
  };
  

const seniorityLevels = [
  { "label": "Proprietário", "value": "owner" },
  { "label": "Fundador", "value": "founder" },
  { "label": "Executivo C-Level", "value": "c_suite" },
  { "label": "Sócio", "value": "partner" },
  { "label": "Vice-presidente", "value": "vp" },
  { "label": "Chefe", "value": "head" },
  { "label": "Diretor", "value": "director" },
  { "label": "Gerente", "value": "manager" },
  { "label": "Sênior", "value": "senior" },
  { "label": "Júnior / Iniciante", "value": "entry" },
  { "label": "Estagiário", "value": "intern" }
]

const EnrichmentModal:React.FC<EnrichmentModalProps> = ({
    enrichmentModalVisible,
    setEnrichmentModalVisible,
    domainToEnrich,
    setDomainToEnrich,
    enrichmentQuantity,
    setEnrichmentQuantity,
    setSelectedLevels,
    selectedLevels,
    setSelectedRecord,
    selectedRecord,
    resultData,
    actualPage,
    pageSize,
    actualPageSize,
    haveEnrichmentCredits,
    companyLoading,
    setCompanyLoading,
    enrichAllResultsLoading,
    setEnrichAllResultsLoading,
    enrichingEmploee,
    setEnrichingEmploee,
    enrichmentResultKey,
    setEnrichMentResultKey,
    setApolloKey,
    setRequestErichmentCredtisKey,
    enrichPerson
    })=>{
        const posthog = usePostHog();
        const requestDomain = ()=>{

            if(!haveEnrichmentCredits) return
            const domains = resultData.map((data: object,index: number)=>{
              const lowerIndexLimit = (actualPage -1) * pageSize
              const higherIndexLimit = lowerIndexLimit + actualPageSize
        
              if(index < higherIndexLimit && index >= lowerIndexLimit ) return data.dominio_email
            }).filter((domain: string)=>(domain !== undefined))
              
            console.log({'dm':domainToEnrich ? [domainToEnrich] : domains,'lv':selectedLevels,'qt':Math.floor(enrichmentQuantity/10)});
            setCompanyLoading(true)
            apSearch(domainToEnrich ? [domainToEnrich] : domains, selectedLevels, Math.floor(enrichmentQuantity / 10), localStorage.getItem("leadPath") ?? '').then(responseId => {

              function pollEnrichment() {
                apGetEnrichment(responseId).then(response => {
                  if (response.message === "Enriquecimento não finalizado.") {
                    console.log("Em processamento, tentando novamente em 5 segundos...");
                    setTimeout(pollEnrichment, 5000);
                    return;
                  }
            
                  console.log("Enriquecimento concluído", response);
            
                  if (response.length === 0) {
                    message.error("Nenhum resultado encontrado");
                    setCompanyLoading(false);
                    return;
                  }
            
                  if (!Array.isArray(response)) {
                    message.error(response.message);
                    setCompanyLoading(false);
                    return;
                  }
            
                  if (Array.isArray(response)) {
                    message.success('Busca Concluída');
                    setApolloKey(Math.random());
            
                    if (selectedRecord && domainToEnrich) {
                      console.log(response);
                      selectedRecord.dados_empresa = response;
                    } else {
                      const domainMap = new Map();
            
                      response.forEach(contato => {
                        if (contato.organization?.primary_domain) {
                          const domain = contato.organization.primary_domain.toLowerCase();
            
                          if (!domainMap.has(domain)) {
                            domainMap.set(domain, []);
                          }
            
                          domainMap.get(domain).push(contato);
                        }
                      });
            
                      for (const emp of resultData) {
                        const empDomain = emp.dominio_email.toLowerCase();
                        emp.dados_empresa = [];
            
                        if (domainMap.has(empDomain)) {
                          emp.dados_empresa.push(...domainMap.get(empDomain));
                        }
            
                        domainMap.forEach((contacts, domain) => {
                          if (empDomain.includes(domain) || domain.includes(empDomain)) {
                            const alreadyAdded = new Set(emp.dados_empresa.map(e => e.id));
                            contacts.forEach(contact => {
                              if (!alreadyAdded.has(contact.id)) {
                                emp.dados_empresa.push(contact);
                              }
                            });
                          }
                        });
            
                        if (emp.dados_empresa.length === 0) {
                          delete emp.dados_empresa;
                        }
                      }
                    }
                  }
                  // Persistir no localStorage para sobreviver a F5
                  localStorage.setItem("leadResults", JSON.stringify(resultData));
                  setCompanyLoading(false);
                }).catch(error => {
                  message.error("Erro na chamada de enrichment:" + error);
                  setCompanyLoading(false);
                });
              }
            
              pollEnrichment();
            
            });
            
            setRequestErichmentCredtisKey(Math.random())
          }
        
          const enrichResultPeople = async (id: string[]) => {
            setEnrichAllResultsLoading(true)
            console.log(id);
            
            const validIds = id.filter(idValue => {
              const company = selectedRecord?.dados_empresa?.find(emp => emp.id === idValue);
              return company && company.email_status === "verified";
            });
        
            if (validIds.length === 0) {
              message.error("Nenhum contato com e-mail verificado disponível para enriquecimento");
              setEnrichAllResultsLoading(false);
              setEnrichingEmploee(undefined);
              return;
            }
        
            const response = await apEnrichment(validIds, false,localStorage.getItem("leadPath") ?? '');
            console.log(response);

            async function pollEnrichment(){
              const responseData = await apGetEnrichment(response)
              console.log(responseData);

                if (responseData.message === "Enriquecimento não finalizado.") {
                      console.log("Em processamento, tentando novamente em 5 segundos...");
                      setTimeout(pollEnrichment, 5000);
                      return;
                    }
              
              if (Array.isArray(responseData)) {
                if (selectedRecord) {
                  const updatedPessoas = [...(selectedRecord.dados_pessoas || [])];
              
                  responseData.forEach(data => {
                    if (data.id) {
                      const existingIndex = updatedPessoas.findIndex(p => p.id === data.id);
                      const enrichedPerson = {
                        id: data.id,
                        nome: data.nome || data.name,
                        email: data.email,
                        linkedin_url: data.linkedin_url,
                        photo_url: data.photo_url,
                        titulo: data.titulo || data.title,
                      };
              
                      if (existingIndex !== -1) {
                        updatedPessoas[existingIndex] = enrichedPerson;
                      } else {
                        updatedPessoas.push(enrichedPerson);
                      }
                    }
                  });
              
                  selectedRecord.dados_pessoas = updatedPessoas;
              
                  // Persistir no localStorage para sobreviver a F5
                  localStorage.setItem("leadResults", JSON.stringify(resultData));

                  setEnrichMentResultKey(Math.random());
                  setApolloKey(Math.random());
                  setEnrichAllResultsLoading(false);
                }
              }
              console.log(selectedRecord);
              
              setEnrichingEmploee(undefined)
            }
            pollEnrichment()
        }     
    return(
        <Modal 
        wrapClassName="draggable-modal" 
        visible={enrichmentModalVisible}
        onCancel={()=>{
          setEnrichmentModalVisible(false)
          setDomainToEnrich(undefined)
          setSelectedRecord(null)
        }}
        
        cancelButtonProps={{style: {display: 'none'}}}
        okButtonProps={{ style:{display:'none'}}}
        title={<span className="enrichModalTitle">{domainToEnrich ? 'Enriquecimento de empresa individual' : 'Enriquecimento de empresa da página'}</span>}

        style={{ top: 0 }}
        bodyStyle={{
          maxHeight: 'calc(80vh)',
          overflowY: 'auto',
        }}

        modalRender={(modal)=>{
          return(          
            <Rnd
            default={{
              x: -200,
              y: 10,
              width: 900,
              height: 400,
            }}
            minWidth={600}
            bounds="window"
            enableResizing={{ top:false, right:true, bottom:false, left:true, topRight:true, bottomRight:false, bottomLeft:false, topLeft:true }}
            cancel=".ant-modal-body, .ant-modal-footer"
          >
            {modal}
          </Rnd>
          )
        }}
      >
          <Form layout='vertical'>
          <div style={{display:'flex', justifyContent:'space-between'}}>
            <Form.Item
                className='MarginFormItem'
                label={
                  <span className="enrichModalLabel"
                  >
                  {domainToEnrich ? 'Quantidade máxima de pessoas' : 'Qtd. máx. pessoas por empresa'}
                    
                  </span>
                }
                name="maxCompanyPages"
              >
                <div style={{display:'flex', alignItems:'center'}}>
                  <Input 
                   prefix={<MinusIcon style={{cursor:'pointer', transform:'scale(1.5)', margin: '0 1em'}} onClick={()=>{if(enrichmentQuantity > 11)setEnrichmentQuantity(enrichmentQuantity -10)}} onMouseDown={e => e.preventDefault()}/>}
                   suffix={<PlusIcon  style={{cursor:'pointer', transform:'scale(1.5)', margin: '0 1em'}} onClick={()=>{if(enrichmentQuantity < 200)setEnrichmentQuantity(enrichmentQuantity +10)}}/>}
                  className="numericInput" readOnly type="number" style={{width:'fit-content', marginLeft:'0.5em', marginRight:'0.5em'}}
                    min={1}
                    max={200}
                    value={enrichmentQuantity}
                    onChange={e=>{setEnrichmentQuantity(Number(e.target.value))}}
                    onBlur={() => posthog.capture('enriquecimento_quantidade_input')}
                  />
                </div>
              </Form.Item>  
              <Form.Item
                className='MarginFormItem'
                label={
                  <span className="enrichModalLabel"
                  >
                    {domainToEnrich ? 'Quantidade de créditos': 'Qtd. máx. créditos por empresa'}
                  </span>
                }
                name="maxCompanyPages"
              >
                <div style={{display:'flex', alignItems:'center'}}>
                  <Input 
                   prefix={<MinusIcon style={{cursor:'pointer', transform:'scale(1.5)', margin: '0 1em'}} onClick={()=>{if(enrichmentQuantity > 11)setEnrichmentQuantity(enrichmentQuantity -10)}} onMouseDown={e => e.preventDefault()}/>}
                   suffix={<PlusIcon  style={{cursor:'pointer', transform:'scale(1.5)', margin: '0 1em'}} onClick={()=>{if(enrichmentQuantity < 200)setEnrichmentQuantity(enrichmentQuantity +10)}}/>}
                    className="numericInput" readOnly type="number" style={{width:'fit-content', marginLeft:'0.5em', marginRight:'0.5em'}}
                    min={1}
                    max={20}
                    value={enrichmentQuantity/10}
                    onChange={e=>{setEnrichmentQuantity(Number(e.target.value))}}
                    onBlur={() => {
                      posthog.capture('enriquecimento_quantidade_creditos_input')
                    }}
                  />
                </div>
              </Form.Item>       
              <Form.Item
                className='MarginFormItem'
                label={
                  <span className="enrichModalLabel">
                    Nível de senioridade
                  </span>
                }
                name="seniority"
              >
                <Select
                  style={{width:'250px'}}
                  mode="multiple"
                  placeholder="Selecione"
                  options={seniorityLevels}
                  onChange={e=>{
                    posthog.capture('enriquecimento_nivel_senioridade_input')
                    setSelectedLevels(e)}}
                />
              </Form.Item>
            </div> 
            <div style={{marginTop:'1em'}}>
              {/* <span>
                {domainToEnrich ? '': `Total máximo de créditos utilizados na busca: ${enrichmentQuantity*actualPageSize/10}` }
              </span> */}
            </div>
              <Form.Item style={{display:'flex', justifyContent:'end'}}>
                <Button
                      loading={companyLoading}
                      type="primary"
                      size="large"
                      icon={<SearchIcon style={{ color: 'white', marginLeft: '1em' }} />}
                      className="submitButton"
                      style={{
                        padding: "14px",
                        margin: "32px 0",
                      }}
                      onClick={() => {
                        posthog.capture('enriquecimento_buscar_botao')
                        requestDomain();

                      }}
                    >
                      Buscar
                    </Button>
              </Form.Item>
 
          </Form>
          {
          selectedRecord?.dados_empresa ?
          <div className='linha-divisoria' style={{paddingTop:'2em', borderTop:'solid thin black', marginBottom:'1em'}}>
            {
              domainToEnrich ? 
              <div style={{ display: 'flex',flexDirection:'row', alignItems:'center', justifyContent: 'space-between', marginBottom: '2em'}}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center' }}>
                    <p style={{ color: '#141774', fontSize: 'large' }}>{selectedRecord.dados_empresa[0].organization?.name}</p>
                    <div style={{ display: 'flex', marginLeft: '2em'}}>
                      {selectedRecord.dados_empresa[0].organization?.linkedin_url ?
                        <Tooltip title={selectedRecord.dados_empresa[0].organization?.linkedin_url}>
                          <FaLinkedinIn
                            style={{ cursor: "pointer", color: "#33EA89", transform: 'scale(1.25)' }}
                            onClick={() => {
                              if (selectedRecord.dados_empresa?.[0]?.organization?.linkedin_url)
                                window.open(`${selectedRecord.dados_empresa?.[0].organization?.linkedin_url}`, "_blank");
                            } } />
                        </Tooltip>
                      : <></>}
                      {selectedRecord.dados_empresa?.[0]?.organization?.website_url ?
                        <Tooltip title={selectedRecord.dados_empresa?.[0]?.organization?.website_url}>
                          <CiGlobe
                            style={{ cursor: "pointer", color: "#33EA89", transform: 'scale(1.25)', marginLeft: '1em' }}
                            onClick={() => {
                              if (selectedRecord.dados_empresa?.[0]?.organization?.website_url)
                                window.open(`${selectedRecord.dados_empresa?.[0].organization?.website_url}`, "_blank");
                            } } />
                        </Tooltip>
                        : <></>}
                    </div>
                </div>
                <Button
                  disabled={selectedRecord.dados_empresa.filter(person => (person.email_status === 'verified' && !selectedRecord.dados_pessoas?.find(data => data.id === person.id)?.email)).length === 0}
                  loading={enrichAllResultsLoading}
                  type="primary"
                  size="large"
                  className="submitButton"
                  onClick={() => {
                    posthog.capture('enriquecimento_enriquecer_todos_botao')
                    const ids = selectedRecord.dados_empresa?.map(emploee => {
                      if (!selectedRecord.dados_pessoas?.find(data => data.id === emploee.id)?.email)
                        return emploee.id;
                        return undefined;
                        });

                    enrichResultPeople(ids?.filter(id => (id !== undefined)));
                  } }
                >
                  {selectedRecord.dados_empresa.filter(person => (person.email_status === 'verified' && !selectedRecord.dados_pessoas?.find(data => data.id === person.id)?.email)).length === 0 ?
                    `Todas as pessoas já enriquecidas`
                    :
                    selectedRecord.dados_empresa.filter(person => (person.email_status === 'verified' && !selectedRecord.dados_pessoas?.find(data => data.id === person.id)?.email)).length === 1 ?
                      `Enriquecer todos (${selectedRecord.dados_empresa.filter(person => (person.email_status === 'verified' && !selectedRecord.dados_pessoas?.find(data => data.id === person.id)?.email)).length} crédito)`
                      :
                      `Enriquecer todos (${selectedRecord.dados_empresa.filter(person => (person.email_status === 'verified' && !selectedRecord.dados_pessoas?.find(data => data.id === person.id)?.email)).length} créditos)`}

                </Button>
              </div>
            : <></>
            }
            <div style={{display:'flex',flexDirection:'column', alignItems:'center'}}>
              <div key={enrichmentResultKey} style={{
                    marginTop:'1em',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)', 
                    gap: '1em',
              }}>
                {
                  
                  selectedRecord.dados_empresa.map(emploee=>{

                    const personData = selectedRecord.dados_pessoas?.find(p => p.id === emploee.id);
                    const linkedinUrl = personData?.linkedin_url;
                    const displayName = personData?.nome || emploee.name || emploee.first_name || emploee.title || '';
                    const photoUrl = personData?.photo_url;

                    return (
                      <div style={{display:'flex', flexDirection:'row', margin: '0.5em 2em'}}>
                        <img src={photoUrl || defaultProfilePicutre} className="EnrichmentModalProfilePciture" onError={(e) => { (e.currentTarget as HTMLImageElement).src = defaultProfilePicutre }} />
                        <div style={{marginLeft:'1em'}}>
                          <p style={{ color: '#141774' }}>{displayName}</p>
                          <p style={{color: '#BFBFBF', fontSize:'small'}}>{emploee.title}</p>
                          {domainToEnrich ? <></> : <p  style={{color:'#249882'}}>{emploee.organization.name}</p>}

                          <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                            <Tooltip title={linkedinUrl}>
                            <FaLinkedinIn
                              style={
                                  linkedinUrl
                                  ? { cursor: "pointer", color: "#33EA89" }
                                  : { color: "gray" }
                              }
                              onClick={() => {
                                if (linkedinUrl)
                                  window.open(`${linkedinUrl}`, "_blank");
                              }}
                            />
                            </Tooltip>
                            {Array.isArray(selectedRecord.dados_pessoas) && selectedRecord.dados_pessoas.find(person => person.id === emploee.id) ?
                              selectedRecord.dados_pessoas?.find(person => person.id === emploee.id)?.email ?<Input
                                size={'small'}
                                style={{ width: "fit-content", fontSize:'small', marginLeft:'1em', maxWidth:'12em', backgroundColor: '#F5F5F5', borderRadius:'30px' }}
                                value={selectedRecord.dados_pessoas?.find(person => person.id === emploee.id)?.email ?? "Sem email disponível"}
                                readOnly
                                suffix={
                                  <Button
                                    type="text"
                                    icon={<IoCopyOutline style={{transform:'scale(0.75)'}}/>}
                                    onClick={async () => {
                                      posthog.capture('enriquecimento_copiar_email_botao')
                                      try {
                                        await navigator.clipboard.writeText(String(selectedRecord.dados_pessoas?.find(person => person.id === emploee.id)?.email ?? "Sem email disponível"));
                                        message.success("E-mail copiado");
                                      } catch (err) {
                                        message.error("Erro ao copiar!");
                                      }
                                    }}
                                  />
                                }
                              /> : <Tooltip title={`E-mail não disponível para enriquecimento`}>
                                  <FaUserTimes style={{ color: '#33EA89', marginLeft: '1em' }} />
                              </Tooltip>
                              :
                              enrichingEmploee && enrichingEmploee.includes(emploee.id)  ? 
                                <div style={{marginLeft:'1em'}}><Spin/></div>
                                :
                                (emploee.email_status === "verified" ? (
                                  <Tooltip title={`Enriquecer ${emploee.first_name}`}>
                                    <FaUser style={{ color: '#33EA89', cursor: 'pointer', marginLeft: '1em' }} onClick={() => {
                                      setEnrichingEmploee(enrichingEmploee ? [...enrichingEmploee, emploee.id] : [emploee.id])
                                      enrichPerson(emploee.id)
                                    }} />
                                  </Tooltip>
                                ) : (
                                  <Tooltip title={`Enriquecimento indisponível`}>
                                    <FaUserTimes style={{ color: 'gray', marginLeft: '1em' }} />
                                  </Tooltip>
                                ))
                            }
                        </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
          : <></>
        }
      </Modal>
    )

}

export default EnrichmentModal